<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Kode | Nama Customer</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.CustInfo"
                @keyup.13.native="lkuItemShow=true"
                :state="!$v.model.customer_id.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Alamat Penagihan</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.billAddr1" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label></label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.billAddr2" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Alamat Pengiriman</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.DeliveryAddr"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Telepon</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.PhoneNo" readonly></b-form-input>
              <b-input-group-prepend>
                <label class="text-right mr-2">Fax.</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.FaxNo" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Jenis Kiriman</label></b-input-group-prepend>
              <b-form-input readonly value="BUKTI IKLAN"></b-form-input>
              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Kota/Area</span></b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.kota_name"
                @keyup.13.native="lkuKoranKotaShow=true"
                @click="lkuKoranKotaShow=true"
                :state="!$v.model.kota_id.$error"
                placeholder="Pilih Kota/Area"
                class="bg-white"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranKotaShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group label-cols-md="2" label>
              <b-input-group-prepend><label>Jurusan</label></b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.jurusan_info"
                @keyup.13.native="lkuKoranJurusanShow=true"
                @click="lkuKoranJurusanShow=true"
                :state="!$v.model.jurusan_id.$error"
                placeholder="Pilih Jurusan"
                class="bg-white"
              ></b-form-input>
              <b-input-group-append><b-btn text="Button" @click="lkuKoranJurusanShow=true"> <i class="fa fa-search"></i></b-btn></b-input-group-append>
              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Titik Drop</span></b-input-group-prepend>
              <b-form-input v-model="model.titikdrop" placeholder="Titik drop"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Titip ke</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.namaAgentDititip"
                @keyup.13.native="lkuKoranAgenShow=true"
                @click="lkuKoranAgenShow=true"
                placeholder="Pilih Agen"
                ref="inputtitipanagen"
                :state="stateTititpKirimKe"
                class="bg-white"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranAgen" @click="lkuKoranAgenShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
                <b-btn text="Button" id="btnKoranAgenCleat" class="ml-1" v-on:click="clearTitipanAgen()">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
              <b-form-invalid-feedback class="text-right">{{errMsgTitipKirim}}</b-form-invalid-feedback>
            </b-input-group>
            <b-row>
              <b-col lg="6">
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Kiriman per hari</label>
                    </b-input-group-prepend>
                    <v-number
                      v-bind:class="$v.model.jmlkirim.$error?'form-control text-right is-invalid':'form-control text-right'"
                      separator=","
                      id="hrg_agen_ecer"
                      v-model="model.jmlkirim"
                      :state="!$v.model.jmlkirim.$error"
                    ></v-number>
                    <b-form-invalid-feedback
                      style="display:unset;"
                      v-show="$v.model.jmlkirim.$error"
                      id="input-1-live-feedback"
                    >Minimal pengiriman adalah 1</b-form-invalid-feedback>
                  </b-input-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Jadwal Muat/Kirim</label>
              </b-input-group-prepend>
              <v-date-picker
                v-model="vSelectedDate"
                :columns="layout.columns"
                :rows="layout.rows"
                :is-expanded="layout.isExpanded"
                :min-date="minDate"
                @dayclick="selectDate"
                mode="multiple"
                is-inline
                class="ml-0"
              />
            </b-input-group>
            <b-row>
              <b-col cols="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label></label>
                  </b-input-group-prepend>
                  <b-button variant="danger" @click="clearDateSelect()">
                    <i class="fa fa-trash"></i> Bersihkan Pilihan Tanggal
                  </b-button>
                </b-input-group>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Jumlah Tanggal :</label>
                    </b-input-group-prepend>
                    <label class="form-control-plaintext text-left">{{vSelectedDate.length}}</label>
                  </b-input-group>
                </b-input-group>

                <b-form-invalid-feedback
                  style="display:unset;"
                  v-show="$v.model.selectedDate.$error"
                  id="input-1-live-feedback"
                >Minimal Jumlah adalah 1</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      <hr />
      <br />
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="List of Agent"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" :customer_group="koranagngroup"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List of Jurusan/Ekspedisi"
      :centered="true"
    >
      <lku-koran-jurusan @click="onSelectKoranJurusan"></lku-koran-jurusan>
    </b-modal>

    <b-modal
      v-model="lkuKoranKotaShow" size="lg"
      :hide-footer="true"
      title="List of Kota Layanan"
      :centered="true"
    >
      <lku-koran-kota @click="onSelectKoranKota"></lku-koran-kota>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .buktiiklanfrm {
      ul {
        -webkit-column-count: 3; /* Old Chrome, Safari and Opera */
        -moz-column-count: 3; /* Old Firefox */
        column-count: 3;
      }
  }
</style>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxLength,
  minLength,
  numeric
} from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import vNumber from "vue-numeric";
import crud from "../../apis/crud";
import customer from "../../apis/customer";
import koran_pesanan from "../../apis/koran_pesanan_buktiiklan";
import lkuKoranJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranKota from "../lookup/lkuKoranKota";
import lkuKoranCust from "../lookup/lkuKoranCust";
import drpDwn from "../../data/dropdown";
import moment from "moment";
toastr.init();

export default {
  components: { lkuKoranCust, vNumber, lkuKoranJurusan, lkuKoranKota },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      jurusan_id: { required },
      kota_id: { required },
      kiriman_code: { required },
      jmlkirim: { required, minValue: minValue(1) },
      selectedDate: { required, minLength: minLength(1) }
    }
  },
  data() {
    return {
      horizontal: true,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKotaShow: false,
      lkuKoranAgenShow: false,
      stateTititpKirimKe: true,
      errMsgTitipKirim: null,
      minDate: new Date(),
      koranagngroup: "KORANAGEN",
      model: {
        customer_id: null,
        kiriman_code: "BUKTIIKLAN",
        jurusan_id: null,
        kota_id: null,
        startdate: null,
        enddate: null,
        jmlkirim: 1,
        selectedDate: []
      },
      customer: {},
      jadwalKirim: [],
      vSelectedDate: [],
      jurusanSelected: {
        jurusan_name: null
      }
    };
  },
  computed: {
    layout() {
      return this.$screens({
        // Default layout for mobile
        default: {
          columns: 1,
          rows: 1,
          isExpanded: true
        },
        // Override for large screens
        md: {
          columns: 2,
          rows: 1,
          isExpanded: false
        },
        lg: {
          columns: 2,
          rows: 1,
          isExpanded: false
        }
      });
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    // jumlahHari() {
    //   if (this.model.startdate && this.model.enddate) {
    //     var a = moment(this.model.enddate);
    //     var b = moment(this.model.startdate);
    //     return a.diff(b, "days") + 1;
    //   } else {
    //     return 0;
    //   }
    // },
    // tot_eksemplar() {
    //   let jumlahHari = this.jumlahHari || 0;
    //   let krmharian = this.model.kirimharian || 0;
    //   let tot_eksemplar = jumlahHari * krmharian;
    //   this.model.subtot_harga = tot_eksemplar * this.model.hrg_langganan;
    //   this.model.tot_harga = this.model.subtot_harga - this.model.potongan || 0;
    //   this.model.tot_eksemplar = tot_eksemplar || 0;
    //   return tot_eksemplar;
    // }
  },
  // watch: {
  //   vSelectedDate(val) {
  //     this.model.selectedDate = val.reduce((arr = [], el) => {
  //       arr.push(moment(el).format("YYYY-MM-DD"));
  //       return arr;
  //     }, []);
  //   }
  // },
  created: async function() {
    if (this.$route.params.tablekey) {
      const rs = await koran_pesanan.detail(this.$route.params);
      console.log('rs: ', rs), 
      this.jadwalKirim=rs.detail;
      this.vSelectedDate = [];
      this.jadwalKirim.forEach((jd,idx)=>{
        this.vSelectedDate.push(new Date(jd.tanggal));
        // this.vSelectedDate.push(jd.tanggal);
        this.jadwalKirim[idx].tanggal = moment(jd.tanggal).format('YYYY-MM-DD');
      });
      this.model = rs.header;
      this.model.selectedDate = this.vSelectedDate.length;
      this.model.CustInfo = rs.header.CustCode + " | " + rs.header.CustName;
      this.customer = rs.header;
      this.kiriman_code = "BUKTIIKLAN";
      this.customer.billAddr1 = `${rs.header.Address1.trim()}${(
        rs.header.Address2 || ""
      ).trim()}`;
      this.customer.billAddr2 = `${rs.header.City.trim()} . Kode pos : ${(
        rs.header.PostCode || "-"
      ).trim()}`;
      this.model.DeliveryAddr = `${rs.header.DeliveryAddr ||
        this.customer.billAddr1 + ". " + rs.header.City.trim()}`;
    }
  },
  methods: {
    selectDate(val) {
      const date = moment(val.date).format('YYYY-MM-DD');
      const index = this.jadwalKirim.findIndex(line => line.tanggal === date);      
      if (index > -1) {
        if (this.jadwalKirim[index].orderlineid) {
            toastr.warn('hapus jadwal kirim seharusnya dilakukan dari Modul Iklan');
        } else {
            this.vSelectedDate.splice(index, 1);
            this.jadwalKirim.splice(index, 1);
        }
      } else {
        this.vSelectedDate.push(new Date(date));
        this.jadwalKirim.push({tanggal: date});
      }
      this.model.selectedDate = this.vSelectedDate.length;
    },    
    onSelectKoranJurusan: async function(_selected) {
      this.model.jurusan_id = _selected.jurusan_id;
      this.model.jurusan_name = _selected.jurusan_name;
      this.model.jurusan_info =
        _selected.jurusan_code + " | " + _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranKota: async function(_selected) {
      this.model.kota_id = _selected.kota_id;
      this.model.kota_name = _selected.kota_name;
      this.model.hrg_langganan = _selected.hrg_langganan;
      this.model.hrg_agen_ecer = _selected.hrg_agen_ecer;
      this.model.hrg_agen_konsi = _selected.hrg_agen_konsi;
      if (_selected.salesae_id){
         if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = `${_selected.crewname || _selected.salesae_name}`;
         }          
      }
      this.lkuKoranKotaShow = false;
    },
    onSelectKoranAgen(_selected) {
      if (this.model.customer_id === null) {
        this.lkuKoranAgenShow = false;
        this.stateTititpKirimKe = false;
        this.errMsgTitipKirim = "Pilih Customer terlebih dahulu.";
        this.invalidModel;
      } else if (
        _selected.customer_id &&
        this.model.customer_id === _selected.customer_id
      ) {
        this.lkuKoranAgenShow = false;
        this.stateTititpKirimKe = false;
        this.errMsgTitipKirim = "Pilih agen yang berbeda untuk dititipkan.";
      } else if (_selected && _selected.customer_id) {
        this.model.namaAgentDititip = `${_selected.CustName} | ${_selected.CustCode}`;
        this.model.kirimtitipke = _selected.customer_id;
        this.lkuKoranAgenShow = false;
      }
    },
    clearTitipanAgen() {
      this.model.namaAgentDititip = null;
      this.model.kirimtitipke = null;
      this.$refs.inputtitipanagen.setValue("");
    },
    clearDateSelect() {
      this.vSelectedDate = [];
    },
    onSelectKoranCust(_selected) {
      if (
        this.model.kirimtitipke !== null &&
        this.model.kirimtitipke === _selected.customer_id
      ) {
        this.lkuKoranAgenShow = false;
        this.stateTititpKirimKe = false;
        this.errMsgTitipKirim = "Pilih Customer yang berbeda dg Agen untuk dititipkan.";
        this.lkuKoranCustShow = false;
      } else if (_selected && _selected.customer_id) {
        this.model.customer_id = _selected.customer_id;
        this.model.CustInfo = _selected.CustCode + " | " + _selected.CustName;
        this.customer = _selected;
        this.customer.billAddr1 = `${_selected.Address1.trim()}${(
          _selected.Address2 || ""
        ).trim()}`;
        this.customer.billAddr2 = `${_selected.City.trim()} . Kode pos : ${(
          _selected.PostCode || "-"
        ).trim()}`;
        this.model.DeliveryAddr = `${_selected.DeliveryAddr ||
          this.customer.billAddr1 + ". " + _selected.City.trim()}`;
        this.lkuKoranCustShow = false;
        this.stateTititpKirimKe = true;
        this.errMsgTitipKirim = null;
      }
        if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = _selected.salesae_name;
        }
        if (!(this.model.kota_id)) {
          this.model.kota_id = _selected.kota_id;
          this.model.kota_name = _selected.kota_name;
        }
        if (!(this.model.jurusan_id)) {
          this.model.jurusan_id = _selected.jurusan_id;
          this.model.jurusan_name = _selected.jurusan_name;
          this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
        }
        if (!(this.model.titikdrop)) {
          this.model.titikdrop = _selected.titikdrop;
        }

    },

    save: async function() {
      this.model.selectedDate = this.vSelectedDate.length;
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (this.jadwalKirim.length==0) {
              toastr.error(`Jadwal kirim belum diisi`, "ERROR MESSAGE");
      } else {
        try {
          this.model.selectedDate= this.jadwalKirim;
          await koran_pesanan.save(this.model);
          toastr.success("Pesanan berhasil disimpan");
          this.close();
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    close() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "koran.pesananbuktiiklan" });
      }
    }
  }
};
</script>